export default __webpack_public_path__ + "static/media/el_regionaalarengu_fond_vertikaalne.0f1a08a8.png";